import queryString from "querystring";
import ApplicationService from "../../services/ApplicationService"
import {
    initProcessFiltersSelectedAction,
    setAppParametersAction,
    setApplicationErrorAction,
    storeInitialDataStartedAction,
    storeInitialDataSuccessAction,
    toggleFirstPartSidebarAction,
    toggleProductCategoryFlagAction,
    updateSearchFiltersSelectedAction, updateProductionFiltersSelectedAction, setActiveTabOnLeftSidebarAction
} from "./actions";
import {hasBeenFilled} from "../../helpers/dynamicFormHelper";
import {AppParametersType} from "../../types/app";
import {getErrorMessageFrom} from "../../helpers/errorsHelper";
import {hasActiveFlow} from "../../helpers/configurationHelper";

export const initAppDispatchAction = (win: Window) => async (dispatch, getState) => {
    try {
        const {
            flow
        } = await dispatch(getAppParametersDispatchAction(win));
        dispatch(getInitialDataDispatchAction());
        const state = getState();
        const appParameters = state.application.appParameters;
        const activeFlow = hasActiveFlow(appParameters);
        let tabNumber = 0;
        if (activeFlow !== false) {
            tabNumber = activeFlow.tabNumber;
        }
        dispatch(setActiveTabOnLeftSidebarAction(tabNumber));
        dispatch(toggleFirstPartSidebarAction(true));
        dispatch(toggleProductCategoryFlagAction(true));
    } catch (error) {
        dispatch(setApplicationErrorAction(getErrorMessageFrom(error, "Error, Application can't be displayed")));
    }
}

const getAppParametersDispatchAction = (win: Window) => async (dispatch) => {
    let query_string = win.location.search.substring(1);

    let appParameters: AppParametersType | null = getAppParametersFromQueryString(query_string ? query_string : "")
    const jwtAuth = sessionStorage.getItem("jwtAuth");
    if (appParameters && jwtAuth) {
        appParameters.jwtAuth = jwtAuth;
    }
    await dispatch(setAppParametersAction(appParameters));
    return appParameters;

    // if (query_string) {
    //   let appParameters: AppParametersType | null = getAppParametersFromQueryString(query_string)
    //   if (appParameters) {
    //       await dispatch(setAppParametersAction(appParameters));
    //     } else {
    //       throw new Error("Error, The query string is not valid");
    //     }
    //   return appParameters;
    // } else {
    //   throw new Error(" "); // workaround to avoid printing an error in case of a missing query string received from the caller
    // }
};

function getAppParametersFromQueryString(query_string: string | null): AppParametersType | null {
    let appParameters: any = {};
    if (query_string) {
        appParameters = queryString.parse(query_string);
    }
    appParameters['language'] = 'en_US'; // default language
    if (!appParameters.hasOwnProperty('flow')) {
        appParameters['flow'] = ''; // default flow
    }
    return isQueryStringAnAppParametersType(appParameters)
        ? appParameters
        : null;
}

function isQueryStringAnAppParametersType(appParameters: any): appParameters is AppParametersType {
    return appParameters && appParameters.hasOwnProperty('flow') && appParameters.hasOwnProperty('language')
}

const getInitialDataDispatchAction = () => async (dispatch) => {
    await dispatch(storeInitialDataStartedAction());
    try {
        const {data} = await ApplicationService.getConfigurations();
        await dispatch(storeInitialDataSuccessAction(data));
    } catch (error) {
        console.log(error);
    }
};

export const changeFilterDispatchAction = (fieldName, fieldValue, ownProps) => async (dispatch) => {
    const {
        configurations,
        scopeConfigurationFields,
        fieldConfigurations,
        formProps: { // they come from Formik
            resetForm,
            setFieldValue
        }
    } = ownProps;

    // if (scopeConfigurationFields === PROCESSING_PARAMETER_SCOPE_CONFIGURATION_FIELDS) {
    //   if (isProcessingServices(configurations) && fieldConfigurations.name === "target") {
    //     if (resetForm) {
    //       resetForm();
    //     }
    //     await dispatch(initProcessFiltersSelectedAction());
    //   }
    // }

    const newFieldValue = hasBeenFilled(fieldValue) ? fieldValue : null;
    if (setFieldValue) setFieldValue(fieldName, newFieldValue);

    // se è un parametro di produzione devo inserirlo dove opportuno
    if (fieldConfigurations.prodParam) {
        await dispatch(updateProductionFiltersSelectedAction({[fieldName]: newFieldValue}));
    }
    await dispatch(updateSearchFiltersSelectedAction({[fieldName]: newFieldValue}));
};
